import { render, staticRenderFns } from "./ItemCard.vue?vue&type=template&id=e2ac3eb2&scoped=true&"
import script from "./ItemCard.vue?vue&type=script&lang=js&"
export * from "./ItemCard.vue?vue&type=script&lang=js&"
import style0 from "./ItemCard.vue?vue&type=style&index=0&id=e2ac3eb2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2ac3eb2",
  null
  
)

export default component.exports